<template>
	<div class="">
		<h6 class="font-weight-bold">LIST OF MENUS</h6>

		<vue-bootstrap4-table 
			:rows="rows"
			:columns="columns"
			:config="config">

			<template slot="id" slot-scope="props">
				<span>
					{{props.row.vbt_id}}
				</span>
			</template>

			<template slot="hasSubMenu" slot-scope="props">
				<span v-if="props.cell_value == 0">
					No
				</span>
				<span v-else>
					Yes
				</span>
			</template>

			<template slot="action" slot-scope="props">
				<div class="btn-group" role="group" aria-label="Action Buttons">
					<button type="button" @click="editMenu(props.cell_value)" class="btn btn-sm mr-1 btn-primary">
						View
					</button>
					<button type="button" @click="deleteMenu(props.cell_value)" class="btn btn-sm btn-danger">
						Delete
					</button>
				</div>     
			</template>

			<template slot="sort-asc-icon">
				<i class="fas fa-sort-up"></i>
			</template>
			<template slot="sort-desc-icon">
				<i class="fas fa-sort-down"></i>
			</template>
			<template slot="no-sort-icon">
				<i class="fas fa-sort"></i>
			</template>
		</vue-bootstrap4-table>
	</div>
</template>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table';
import { mapState } from 'vuex';
export default {
	name: "ListMenu",

	components: {
        VueBootstrap4Table,
	},

	props:{
		rows: Array
	},

	computed: {
        ...mapState(['token']),
	},
	
	data() {
		return {
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Menu Name",
                    name: "menuName",
                    sort: true,
                },
                {
                    label: "Menu URL",
                    name: "menuUrl",
                    sort: true,
                },
                {
                    label: "Has Sub-Menu",
                    name: "hasSubMenu",
                    slot_name: "hasSubMenu",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action"
                },
            ],
            config: {
                card_mode: false,
                checkbox_rows: false,
                rows_selectable: false,
                show_refresh_button: false,
                show_reset_button: false,
                global_search: {
                    placeholder: "Search",
                    visibility: true,
                    case_sensitive: false,
                },
            },
		}
	},

	methods: {
		editMenu(menuId){
			this.$emit('editmenu', menuId);
		},

		deleteMenu(menuId){
			this.$emit('deletemenu', menuId);
		},
	}
}
</script>